export const GenderConst = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
};

export const GenderLabel: Record<number, string> = {
  [GenderConst.MALE]: "Masculino",
  [GenderConst.FEMALE]: "Feminino",
  [GenderConst.OTHER]: "Outro",
};

export const MaritalStatusConst = {
  SINGLE: 1,
  MARRIED: 2,
  DIVORCED: 3,
  WIDOWED: 4,
  STABLE_UNION: 5,
  SEPARATED: 6,
};

export const MaritalStatusLabel: Record<number, string> = {
  [MaritalStatusConst.SINGLE]: "Solteiro(a)",
  [MaritalStatusConst.MARRIED]: "Casado(a)",
  [MaritalStatusConst.DIVORCED]: "Divorciado(a)",
  [MaritalStatusConst.WIDOWED]: "Viúvo(a)",
  [MaritalStatusConst.STABLE_UNION]: "União Estável",
  [MaritalStatusConst.SEPARATED]: "Separado(a)",
};

export const EthnicityConst = {
  WHITE: 1,
  BLACK: 2,
  BROWN: 3,
  YELLOW: 4,
  INDIGENOUS: 5,
  NOT_INFORMED: 6,
};

export const EthnicityLabel: Record<number, string> = {
  [EthnicityConst.WHITE]: "Branca",
  [EthnicityConst.BLACK]: "Preta",
  [EthnicityConst.BROWN]: "Parda",
  [EthnicityConst.YELLOW]: "Amarela",
  [EthnicityConst.INDIGENOUS]: "Indígena",
  [EthnicityConst.NOT_INFORMED]: "Não informado",
};

export const EducationLevelConst = {
  ILLITERATE: 1,
  FUNDAMENTAL_INCOMPLETE: 2,
  FUNDAMENTAL_COMPLETE: 3,
  MIDDLE_INCOMPLETE: 4,
  MIDDLE_COMPLETE: 5,
  HIGHER_INCOMPLETE: 6,
  HIGHER_COMPLETE: 7,
  POSTGRADUATE: 8,
  MASTERS: 9,
  DOCTORATE: 10,
};

export const EducationLevelLabel: Record<number, string> = {
  [EducationLevelConst.ILLITERATE]: "Analfabeto",
  [EducationLevelConst.FUNDAMENTAL_INCOMPLETE]: "Fundamental Incompleto",
  [EducationLevelConst.FUNDAMENTAL_COMPLETE]: "Fundamental Completo",
  [EducationLevelConst.MIDDLE_INCOMPLETE]: "Médio Incompleto",
  [EducationLevelConst.MIDDLE_COMPLETE]: "Médio Completo",
  [EducationLevelConst.HIGHER_INCOMPLETE]: "Superior Incompleto",
  [EducationLevelConst.HIGHER_COMPLETE]: "Superior Completo",
  [EducationLevelConst.POSTGRADUATE]: "Pós-graduação",
  [EducationLevelConst.MASTERS]: "Mestrado",
  [EducationLevelConst.DOCTORATE]: "Doutorado",
};

export const PaymentFrequencyConst = {
  MONTHLY: 1,
  BIWEEKLY: 2,
  WEEKLY: 3,
  DAILY: 4,
  HOURLY: 5,
  TASK: 6,
};

export const PaymentFrequencyLabel: Record<number, string> = {
  [PaymentFrequencyConst.MONTHLY]: "Mensal",
  [PaymentFrequencyConst.BIWEEKLY]: "Quinzenal",
  [PaymentFrequencyConst.WEEKLY]: "Semanal",
  [PaymentFrequencyConst.DAILY]: "Diário",
  [PaymentFrequencyConst.HOURLY]: "Por Hora",
  [PaymentFrequencyConst.TASK]: "Por Tarefa",
};

export const VacationStatusConst = {
  ACQUIRING: 1,
  SCHEDULED: 2,
  TAKEN: 3,
};

export const VacationStatusLabel: Record<number, string> = {
  [VacationStatusConst.ACQUIRING]: "Em aquisição",
  [VacationStatusConst.SCHEDULED]: "Agendada",
  [VacationStatusConst.TAKEN]: "Gozada",
};
